import { useEffect } from "react"
import { Loading } from "./components"

export default function HardRefresh() {
  useEffect(() => {
    !__TEST__ && window.location.replace(location.href)
  }, [])
  return <Loading />
}
